import { el } from "@dhx/ts-common/dom";
import { getCount } from "./helpers";

export function imageButton(item: any, widgetName: string) {
	const baseClass = "dhx_" + widgetName + "-button-image";
	const isRibbon = widgetName === "ribbon";
	return el("button.dhx_button", {
		class: baseClass + (item.size ? " " + baseClass + "--" + item.size : "") +
			(!item.value && item.src ? " " + baseClass + "--icon" : "") +
			(isRibbon && item.$openIcon ? " " + baseClass + "--select" : "") +
			(item.active ? " " + baseClass + "--active" : ""),
		dhx_id: item.id,
		type: "button"
	}, [
		isRibbon && item.value && item.$openIcon && el("span.dxi.dxi-menu-right", {
			class: baseClass + "__caret"
		}),
		item.html ?
			el("div", {
				"class": baseClass + "__text",
				".innerHTML": item.html
			}) :
			item.value && el("span", {
				class: baseClass + "__text",
			}, item.value),
		item.src && el("span", {
			class: baseClass + "__image",
			style: {backgroundImage: `url(${item.src})`}
		}),
		item.count > 0 && getCount(item, baseClass + "__count", true),
	]);
}